import React from 'react';
import {
    FETCH_SUCCESS,
    FETCH_START,
    DISCH_PENDING_DATA,
    DISCH_PENDING_COUNT,
    DISCHARGE_SUMMARY_COUNTS,
    DISCH_INPROGRESS_DATA,
    DISCH_INPROGRESS_COUNT,
    FETCH_ERROR,
    DISCH_REJECT_DATA,
    DISCH_REJECT_COUNT,
    DISCH_COMPLETE_DATA,
    DISCH_COMPLETE_COUNT,
    DISCH_TIMEDIFF_COUNT,
    DISCH_CLIENT_LIST,
    MRD_HEADER_MASTER_SAVE,
    SAVE_DISCHARGE_SUMMARY,
 }from '../../shared/constants/ActionTypes';
import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {fetchError, onWriteCloudWatchLog} from './Common';
import IntlMessages from '../../@crema/utility/IntlMessages';
var streamname = 'Redux_Actions';
var filename = 'Dischargesummary.js';

export const onGetDischargeSummaryPendingListData = ({
  userCode,
  userId,
  status,
  offset,
  limit,
  filtercheckInStartDate,
  filtercheckInEndDate,
  clientId,
  sortBy
}) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});

    const body = {
      sortBy,
      userCode,
      userId,
      status,
      offset,
      limit,
      filtercheckInStartDate,
      filtercheckInEndDate,
      clientId,
    };

    try {
      //Call pending list Token  - Get Token
      jwtAxios
        .post('v1/disChargeRoutes/getDischargeSummaryPendingJwt', body)
        .then((data) => {
          if (data.status === 200) {
            //Call pending list data - Get pending list data using token
            try {
              const jwtToken = data.data.body['token'];
              const bodytoken = {
                userCode,
                userId,
                status,
                offset,
                limit,
                filtercheckInStartDate,
                filtercheckInEndDate,
                jwtToken,
                clientId,
                sortBy
              };
              jwtAxios
                .post('v1/disChargeRoutes/getDischargeSummaryPending', bodytoken)
                .then((data) => {
                  if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({
                      type: DISCH_PENDING_DATA,
                      payload: data.data.body.data,
                    });
                    dispatch({
                      type: DISCH_PENDING_COUNT,
                      payload: data.data.body.data.totalCount,
                    });
                    dispatch({
                      type: DISCH_TIMEDIFF_COUNT,
                      payload: data.data.body.data.timediffcount,
                    });

                    //Clear Erxdatas every pending list loading
                  } else {
                    dispatch({
                      type: FETCH_ERROR,
                      payload: <IntlMessages id='message.somethingWentWrong' />,
                    });
                  }
                })
                .catch((error) => {
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'onGetDischargeSummaryPendingListData',
                      body.userCode,
                      error,
                    ),
                  );
                  dispatch({type: FETCH_ERROR, payload: error.message});
                });
            } catch (err) {
              dispatch(fetchError(err.response.message));
              dispatch(
                onWriteCloudWatchLog(
                  streamname,
                  filename,
                  'onGetDischargeSummaryPendingListData',
                  body.userCode,
                  err,
                ),
              );
            }
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: <IntlMessages id='message.somethingWentWrong' />,
            });
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'onGetDischargeSummaryPendingListData',
              body.userCode,
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGetDischargeSummaryPendingListData',
          body.userCode,
          err,
        ),
      );
    }
  };
};

export const onGetDischargeSummaryCounts = ({
  userCode,
  userId
}) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});

    const body = {
      userCode,
      userId
    };

    try {
      //Call pending list Token  - Get Token
      jwtAxios
        .post('v1/disChargeRoutes/getDischargeSummaryCountJwt', body)
        .then((data) => {
          if (data.status === 200) {
            //Call pending list data - Get pending list data using token
            try {
              const jwtToken = data.data.body['token'];
              const bodytoken = {
                userCode,
                userId,
                jwtToken,
              };
              jwtAxios
                .post('v1/disChargeRoutes/getDischargeSummaryCount', bodytoken)
                .then((data) => {
                  if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    const getdata = data.data.body.data;
                    dispatch({
                      type: DISCHARGE_SUMMARY_COUNTS,
                      payload: getdata,
                    });
                    dispatch({
                      type: DISCH_CLIENT_LIST,
                      payload: getdata?.clientList,
                    });

                    //Clear Erxdatas every pending list loading
                  } else {
                    dispatch({
                      type: FETCH_ERROR,
                      payload: <IntlMessages id='message.somethingWentWrong' />,
                    });
                  }
                })
                .catch((error) => {
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'onGetDischargeSummaryCounts',
                      body.userCode,
                      error,
                    ),
                  );
                  dispatch({type: FETCH_ERROR, payload: error.message});
                });
            } catch (err) {
              dispatch(fetchError(err.response.message));
              dispatch(
                onWriteCloudWatchLog(
                  streamname,
                  filename,
                  'onGetDischargeSummaryCounts',
                  body.userCode,
                  err,
                ),
              );
            }
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: <IntlMessages id='message.somethingWentWrong' />,
            });
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'onGetDischargeSummaryCounts',
              body.userCode,
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGetDischargeSummaryCounts',
          body.userCode,
          err,
        ),
      );
    }
  };
};

export const onGetDischargeSummaryInprogressData = ({
  userCode,
  userId,
  status,
  offset,
  limit,
  filtercheckInStartDate,
  filtercheckInEndDate,
  clientId,
}) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    const body = {
      userCode,
      userId,
      status,
      offset,
      limit,
      filtercheckInStartDate,
      filtercheckInEndDate,
      clientId,
    };

    try {
      //Call pending list Token  - Get Token
      jwtAxios
        .post('v1/disChargeRoutes/getDischargeSummaryInprogressJwt', body)
        .then((data) => {
          if (data.status === 200) {
            //Call pending list data - Get pending list data using token
            try {
              const jwtToken = data.data.body['token'];
              const bodytoken = {
                userCode,
                userId,
                status,
                offset,
                limit,
                filtercheckInStartDate,
                filtercheckInEndDate,
                jwtToken,
                clientId,
              };
              jwtAxios
                .post('v1/disChargeRoutes/getDischargeSummaryInprogress', bodytoken)
                .then((data) => {
                  if (data?.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({
                      type: DISCH_INPROGRESS_DATA,
                      payload: data?.data?.body?.data,
                    });
                    dispatch({
                      type: DISCH_INPROGRESS_COUNT,
                      payload: data?.data?.body?.data?.totalCount,
                    });

                    //Clear Erxdatas every pending list loading
                  } else {
                    dispatch({
                      type: FETCH_ERROR,
                      payload: <IntlMessages id='message.somethingWentWrong' />,
                    });
                  }
                })
                .catch((error) => {
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'onGetDischargeSummaryInprogressData',
                      body.userCode,
                      error,
                    ),
                  );
                  dispatch({type: FETCH_ERROR, payload: error.message});
                });
            } catch (err) {
              dispatch(fetchError(err.response.message));
              dispatch(
                onWriteCloudWatchLog(
                  streamname,
                  filename,
                  'onGetDischargeSummaryInprogressData',
                  body.userCode,
                  err,
                ),
              );
            }
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: <IntlMessages id='message.somethingWentWrong' />,
            });
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'onGetDischargeSummaryInprogressData',
              body.userCode,
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGetDischargeSummaryInprogressData',
          body.userCode,
          err,
        ),
      );
    }
  };
};

export const onGetDischargeSummaryRejectedData = ({
  userCode,
  userId,
  status,
  offset,
  limit,
  filtercheckInStartDate,
  filtercheckInEndDate,
  filterCompletedStartDate, 
  filterCompletedEndDate,
  clientId,
}) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    const body = {
      userCode,
      userId,
      status,
      offset,
      limit,
      filtercheckInStartDate,
      filtercheckInEndDate,
      filterCompletedStartDate, 
      filterCompletedEndDate,
      clientId,
    };

    try {
      //Call pending list Token  - Get Token
      jwtAxios
        .post('v1/disChargeRoutes/getDischargeSummaryRejectedJwt', body)
        .then((data) => {
          if (data.status === 200) {
            //Call pending list data - Get pending list data using token
            try {
              const jwtToken = data.data.body['token'];
              const bodytoken = {
                userCode,
                userId,
                status,
                offset,
                limit,
                filtercheckInStartDate,
                filtercheckInEndDate,
                filterCompletedStartDate, 
                filterCompletedEndDate,
                clientId,
                jwtToken,
              };
              jwtAxios
                .post('v1/disChargeRoutes/getDischargeSummaryRejected', bodytoken)
                .then((data) => {
                  if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({
                      type: DISCH_REJECT_DATA,
                      payload: data?.data?.body?.data,
                    });
                    dispatch({
                      type: DISCH_REJECT_COUNT,
                      payload: data?.data?.body?.data?.totalCount,
                    });

                    //Clear Erxdatas every pending list loading
                  } else {
                    dispatch({
                      type: FETCH_ERROR,
                      payload: <IntlMessages id='message.somethingWentWrong' />,
                    });
                  }
                })
                .catch((error) => {
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'onGetDischargeSummaryRejectedData',
                      body.userCode,
                      error,
                    ),
                  );
                  dispatch({type: FETCH_ERROR, payload: error.message});
                });
            } catch (err) {
              dispatch(fetchError(err.response.message));
              dispatch(
                onWriteCloudWatchLog(
                  streamname,
                  filename,
                  'onGetDischargeSummaryRejectedData',
                  body.userCode,
                  err,
                ),
              );
            }
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: <IntlMessages id='message.somethingWentWrong' />,
            });
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'onGetDischargeSummaryRejectedData',
              body.userCode,
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGetDischargeSummaryRejectedData',
          body.userCode,
          err,
        ),
      );
    }
  };
};

export const onGetDischargeSummaryCompletedData = ({
  userCode,
  userId,
  status,
  offset,
  limit,
  filtercheckInStartDate,
  filtercheckInEndDate,
  filterCompletedStartDate, 
  filterCompletedEndDate,
  clientId,
}) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    const body = {
      userCode,
      userId,
      status,
      offset,
      limit,
      filtercheckInStartDate,
      filtercheckInEndDate,
      filterCompletedStartDate, 
      filterCompletedEndDate,
      clientId,
    };

    try {
      //Call pending list Token  - Get Token
      jwtAxios
        .post('v1/disChargeRoutes/getDischargeSummaryCompletedJwt', body)
        .then((data) => {
          if (data.status === 200) {
            //Call pending list data - Get pending list data using token
            try {
              const jwtToken = data.data.body['token'];
              const bodytoken = {
                userCode,
                userId,
                status,
                offset,
                limit,
                filtercheckInStartDate,
                filtercheckInEndDate,
                filterCompletedStartDate,
                filterCompletedEndDate,
                clientId,
                jwtToken,
              };
              jwtAxios
                .post('v1/disChargeRoutes/getDischargeSummaryCompleted', bodytoken)
                .then((data) => {
                  if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({
                      type: DISCH_COMPLETE_DATA,
                      payload: data?.data?.body?.data,
                    });
                    dispatch({
                      type: DISCH_COMPLETE_COUNT,
                      payload: data?.data?.body?.data?.totalCount,
                    });

                    //Clear Erxdatas every pending list loading
                  } else {
                    dispatch({
                      type: FETCH_ERROR,
                      payload: <IntlMessages id='message.somethingWentWrong' />,
                    });
                  }
                })
                .catch((error) => {
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'onGetDischargeSummaryCompletedData',
                      body.userCode,
                      error,
                    ),
                  );
                  dispatch({type: FETCH_ERROR, payload: error.message});
                });
            } catch (err) {
              dispatch(fetchError(err.response.message));
              dispatch(
                onWriteCloudWatchLog(
                  streamname,
                  filename,
                  'onGetDischargeSummaryCompletedData',
                  body.userCode,
                  err,
                ),
              );
            }
          } else {
            dispatch({
              type: FETCH_ERROR,
              payload: <IntlMessages id='message.somethingWentWrong' />,
            });
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'onGetDischargeSummaryCompletedData',
              body.userCode,
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGetDischargeSummaryCompletedData',
          body.userCode,
          err,
        ),
      );
    }
  };
};

export const saveMRDHeader = (value) => {
  return (dispatch) => {
    // dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/disChargeRoutes/saveMRDHeaderJwt', value)
        .then((data) => {
          try {
            jwtAxios
              .post('v1/disChargeRoutes/saveMRDHeader', {
                jwtToken: data.data.body['token'],
              })
              .then((data) => {
                // dispatch({type: FETCH_SUCCESS});
                if (data?.status === 200) {
                  if (data?.data?.body?.status) {
                    dispatch({
                      type: MRD_HEADER_MASTER_SAVE,
                      payload: data.data.body.status
                        ? data.data.body.status
                        : '',
                    });
                  }
                } else {
                  dispatch({type: FETCH_ERROR, payload: 'error'});
                }
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'saveMRDHeader',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'saveMRDHeader',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'saveMRDHeader',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'saveMRDHeader', '0', err),
      );
    }
  };
};

export const saveDischargeSummary = (value,list) => {
  return (dispatch) => {
    // dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/disChargeRoutes/saveDischargeSummaryJwt', value)
        .then((data) => {
          try {
            jwtAxios
              .post('v1/disChargeRoutes/saveDischargeSummary', {
                jwtToken: data.data.body['token'],
                list: list,
              })
              .then((data) => {
                // dispatch({type: FETCH_SUCCESS});
                if (data?.status === 200) {
                  if (data?.data?.body?.status) {
                    dispatch({
                      type: SAVE_DISCHARGE_SUMMARY,
                      payload: data.data.body.status
                        ? data.data.body.status
                        : '',
                    });
                  }
                } else {
                  dispatch({type: FETCH_ERROR, payload: 'error'});
                }
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'saveDischargeSummary',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'saveDischargeSummary',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'saveDischargeSummary',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'saveDischargeSummary', '0', err),
      );
    }
  };
};

